import uuid from 'uuid/v4';
import qs from 'query-string';
import chroma from 'chroma-js';
import { DesignDemoState, StyleByIdMap } from '..';
import { ACCEPTED_LAYOUT_VALUES, BASE_FONT_KEYS, DEFAULT_PALETTE } from '../constants';
import { CreateEventQueryStringComponent, LocationPalette, CreateEventColorPalette } from '../types';

export const generateCreateEventQueryString = (
  designOptions: DesignDemoState['sections'],
  palette: LocationPalette,
  styleByIdMap: StyleByIdMap
): string | null => {
  const { layout, themes, colors, fonts } = designOptions;

  const queryString: CreateEventQueryStringComponent = {};

  if (ACCEPTED_LAYOUT_VALUES.has(layout.layout)) {
    queryString.template = layout.layout;
  }

  if (styleByIdMap[themes.themeKey]) {
    queryString.theme = themes.themeKey;
  }

  if (BASE_FONT_KEYS.includes(fonts.font)) {
    queryString.font = fonts.font;
  }

  if (themes) {
    queryString.usesWeddingColor = themes.useSuggestedBackgroundColor ? false : true;
  }

  if (palette) {
    const { accentColor, accentText, baseText, accentLightText, baseLightText } = palette;

    let baseColor: number[] = [];
    try {
      const rgbaValue = chroma(colors.hex).rgba();
      // reformatting base color to be received by /createwedding
      baseColor = [...rgbaValue.slice(0, 3).map(x => x / 255), rgbaValue[3]];
    } catch (e) {
      baseColor = DEFAULT_PALETTE.baseColor;
    }

    const formattedPalette: CreateEventColorPalette = {
      paletteId: uuid(),
      paletteName: 'My Custom Color',
      accentColor,
      baseColor,
      accentText,
      baseText,
      accentLightText,
      baseLightText
    };
    queryString.palette = JSON.stringify(formattedPalette);
  }

  return Object.keys(queryString).length ? qs.stringify(queryString, { sort: false } as any) : null;
};
